import {getRouteWithVariablesReplaced} from '@netx/core-next/utils/route';
import {SEARCH_VISUAL_EVENT} from './actions';

export enum SearchVisualRoute {
	ASSET = `search/visual/asset/:assetId(/page/:page)`,
	COLOR = `search/visual/color/:color(/page/:page)`,
}

export const SEARCH_VISUAL_ROUTE_REGEX = {
	// eslint-disable-next-line security/detect-unsafe-regex
	ASSET: /^\/?search\/visual\/asset\/\d+(\/page\/\d+)?$/,
	// eslint-disable-next-line security/detect-unsafe-regex
	COLOR: /^\/?search\/visual\/color\/[0-9a-fA-F]{6}(\/page\/\d+)?$/,
};

export const SEARCH_VISUAL_DATA_FROM_ROUTE = {
	COLOR: (route: string) => {
		if (!route.match(SEARCH_VISUAL_ROUTE_REGEX.COLOR)) return null;
		const parts = route.split('/');
		const color = parts[3];
		const page = parseInt(parts[5]);
		return {
			color,
			page: isNaN(page) ? undefined : page,
		};
	},
};

export const SEARCH_ROUTE_REPLACER = {
	ASSET: <I extends number, P extends number | undefined>(id: I, page?: P) => {
		const route = getRouteWithVariablesReplaced<
			SearchVisualRoute.ASSET,
			P extends undefined
				? `search/visual/asset/${I}`
				: `search/visual/asset/${I}/page/${P}`
		>(SearchVisualRoute.ASSET, id, page);
		if (!route || !route.match(SEARCH_VISUAL_ROUTE_REGEX.ASSET))
			throw new Error(`Invalid route: ${route}`);

		return route;
	},
	COLOR: <C extends string, P extends number | undefined>(
		color: C,
		page?: P,
	) => {
		const route = getRouteWithVariablesReplaced<
			SearchVisualRoute.COLOR,
			P extends undefined
				? `search/visual/color/${C}`
				: `search/visual/color/${C}/page/${P}`
		>(SearchVisualRoute.COLOR, color, page);
		if (!route || !route.match(SEARCH_VISUAL_ROUTE_REGEX.COLOR))
			throw new Error(`Invalid route: ${route}`);

		return route;
	},
};

export const routes = <const>{
	[SearchVisualRoute.ASSET]: SEARCH_VISUAL_EVENT.ASSET,
	[SearchVisualRoute.COLOR]: SEARCH_VISUAL_EVENT.COLOR,
};

export default routes;
